import { Action, createReducer, on } from '@ngrx/store';
import { Collection, Offer } from '@app/core/_models/offer-interface';
import * as OfferActions from '@app/core/store/offers/offers-actions';
import { PaginationInfo } from '@app/shared/types/pagination';

export interface State {
  activeOffer: Offer | null;
  filteredOffers: Offer[];
  collections: Collection[];
  tags: string[];
  stores: string[];
  paginationInfo: PaginationInfo | null;
}

export const initialState: State = {
  activeOffer: null,
  filteredOffers: [],
  collections: [],
  tags: [],
  stores: [],
  paginationInfo: null,
};

export const reducers = createReducer(initialState,
  on(OfferActions.metadataLoaded, (state: State, { data }) => {
    return { ...state, ...data };
  }),
  on(OfferActions.offersLoaded, (state: State, { offers, paginationInfo }) => {
    return { ...state, filteredOffers: offers, paginationInfo };
  }),
  on(OfferActions.clearFilteredOffers, (state: State) => {
    return { ...state, filteredOffers: [] };
  }),
  on(OfferActions.offerLoaded, (state: State, { offer }) => {
    return { ...state, activeOffer: offer };
  }),
);

export function reducer(state: State | undefined, action: Action): State {
  return reducers(state, action);
}
